
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import React from 'react';
import Header from "../components/common/Header";
import useTranslation from "next-translate/useTranslation";
import MainLayout from "../layouts/main";
import Footer from "../components/common/Footer";
import Banner from "../components/pages/ecosystem/Banner";
import Functionality from "../components/pages/ecosystem/wallet/Functionality";
import Discover from "../components/pages/ecosystem/Discover";
import HowItWorks from "../components/pages/ecosystem/HowItWorks";
import CoinList from "../components/pages/ecosystem/wallet/CoinList";
const ColdwareWallet = () => {
    const { t } = useTranslation();
    const banner = t('coldware_wallet:banner', {}, { returnObjects: true });
    const how_it_works = t('coldware_wallet:how_it_works', {}, { returnObjects: true });
    const seo = t('common:seo', {}, { returnObjects: true });
    const discover = t('coldware_wallet:discover', {}, { returnObjects: true });
    const icons = {
        "utilize": <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <g clipPath="url(#clip0_159_799)">
                <path d="M14.122 0L21 6.878H1.18701" stroke="#000034" strokeWidth="2"/>
                <path d="M9.95651 23.959L2.99951 17H22.6875" stroke="#000034" strokeWidth="2"/>
            </g>
            <defs>
                <clipPath id="clip0_159_799">
                    <rect width="24" height="24" fill="white"/>
                </clipPath>
            </defs>
        </svg>,
        "access": <svg xmlns="http://www.w3.org/2000/svg" width="21" height="22" viewBox="0 0 21 22" fill="none">
            <path d="M1.00005 16.5007L20.0526 5.50073" stroke="#000034" strokeWidth="2"/>
            <path d="M1.00005 5.50073L20.0526 16.5007" stroke="#000034" strokeWidth="2"/>
            <path d="M10.524 22L10.524 0" stroke="#000034" strokeWidth="2"/>
        </svg>,
        "explore": <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
            <rect x="17.1123" width="4.88889" height="4.88889" fill="#000034"/>
            <rect x="7.92053" y="0.440002" width="4.4" height="4.4" fill="#000034"/>
            <rect x="12.2211" y="4.88885" width="4.88889" height="4.88889" fill="#000034"/>
            <rect x="17.1588" y="9.67999" width="4.4" height="4.4" fill="#000034"/>
            <rect x="13.0375" y="15.4814" width="3.25926" height="3.25926" fill="#000034"/>
            <rect x="8.96252" y="19.5555" width="2.44444" height="2.44444" fill="#000034"/>
            <rect x="8.14612" y="10.5926" width="3.25926" height="3.25926" fill="#000034"/>
            <rect x="4.07483" y="15.4814" width="2.44444" height="2.44444" fill="#000034"/>
            <rect y="19.5555" width="1.62963" height="1.62963" fill="#000034"/>
            <rect x="3.25842" y="5.70374" width="3.25926" height="3.25926" fill="#000034"/>
            <rect y="11.4074" width="2.44444" height="2.44444" fill="#000034"/>
        </svg>
    };
    return (<MainLayout title={seo.coldware_wallet.title} description={seo.coldware_wallet.description} keywords={seo.coldware_wallet.keywords} page={'ecosystem wallet'} alternate={'coldware-wallet'} canonical={'/coldware-wallet'}>
            <Header t={t}/>
            <main className='main'>
                <Banner banner={banner} icon={"wallet_icon"}/>
                <Functionality t={t}/>
                <CoinList t={t}/>
                <Discover img={"cold_wallet/discover/discover"} discover={discover} icons={icons}/>
                <HowItWorks how_it_works={how_it_works}/>
            </main>
            <Footer t={t}/>
        </MainLayout>);
};
export default ColdwareWallet;

    async function __Next_Translate__getStaticProps__19763357ea2__(ctx) {
      
      return {
        
        
        props: {
          
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/coldware-wallet',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__19763357ea2__ as getStaticProps }
  